export default __webpack_public_path__ + "static/media/hornhippie_icon_teal CIRCULAR.363e9fcd.png";